import React, { useCallback, useReducer, useState, createContext } from 'react';
import { node, func, oneOfType } from 'prop-types';
import reducers, { CLICK_ITEM, CLICK_MENU, HOVER_ITEM, RESET } from './reducers';

const TableContext = createContext();

const TableProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducers, {
    menu: '',
    content: {},
    selected: [],
  });
  const [hover, setHover] = useState(-1);

  const dispatchHelper = useCallback((type, payload) => {
    dispatch({ type, payload });
  }, []);

  const handleClickItem = useCallback((payload) => {
    dispatchHelper(CLICK_ITEM, payload);
  }, []);

  const handleHover = useCallback((content) => {
    dispatchHelper(HOVER_ITEM, { content });
  });

  const handleClickMenu = useCallback((payload) => {
    dispatchHelper(CLICK_MENU, payload);
  });

  const handleReset = useCallback(() => {
    dispatchHelper(RESET, {});
  });

  const valueProps = {
    hover,
    setHover,
    handleHover,
    handleClickItem,
    handleClickMenu,
    handleReset,
    menu: state.menu,
    content: state.content,
    selected: state.selected,
  };

  return <TableContext.Provider value={valueProps}>{children}</TableContext.Provider>;
};

TableProvider.propTypes = {
  children: oneOfType([node, func]),
};

TableProvider.defaultProps = {
  children: null,
};

export { TableProvider as default, TableContext };
